<app-pan-section-header class="mt-4" title="Locations">
  <div action class="flex gap-2">
    <app-pan-button color="info" [matMenuTriggerFor]="menu" icon="filter_list">
      Presets
      <mat-menu #menu="matMenu">
        @for (preset of presetFilters; track $index) {
          <button mat-menu-item (click)="setFilterModel(preset.filters)">
            <span>{{ preset.label }}</span>
          </button>
        }
      </mat-menu>
    </app-pan-button>
  </div>
</app-pan-section-header>

<ag-grid-angular #locationGrid [rowData]="branchLocations()" [columnDefs]="locationColumns" [gridOptions]="locationTable"></ag-grid-angular>
